import { setCookie, getCookie } from './cookie';

import SuperStorage from './shared/super-storage';

/**
 * This class uses localStorage and makes it work
 * like sessionStorage but persistant between tabs.
 * It uses a cookie to check the session is still on.
 * If not, the values prefixed with `session.` are removed
 * form the localStorage.
 */

const SESSION_KEY = 'session.';
const COOKIE_KEY = 'session.active';

class SuperSessionStorage extends SuperStorage {
  constructor() {
    super(window.localStorage);
  }

  get(key: string, defaultValue = null) {
    return super.get(SESSION_KEY + key, defaultValue);
  }

  set(key: string, value: any) {
    return super.set(SESSION_KEY + key, value);
  }

  remove(key: string) {
    return super.remove(SESSION_KEY + key);
  }

  clear() {
    return super.clear(SESSION_KEY);
  }
}

export let superSessionStorage = new SuperSessionStorage();

// Use cookie to check a session is on
// and remove session data from localStorage if not.

const isSessionOpen = !!getCookie(COOKIE_KEY);

if (!isSessionOpen) {
  setCookie(COOKIE_KEY, 'YES');
  superSessionStorage.clear();
}

